import { factory, Box } from '@kohler-dsm-library/kohler-core';
import clsx from 'clsx';
import React from 'react';
import { PromoBanner } from './subcomponents/PromoBanner/PromoBanner.mjs';
import { InfoBanner } from './subcomponents/InfoBanner/InfoBanner.mjs';
import { GlobalBanner } from './subcomponents/GlobalBanner/GlobalBanner.mjs';

const MessageBanner = factory((props, ref) => {
  const { className, type, mod = "white", ...rest } = props;
  switch (type) {
    case "promo": {
      const { content, carouselControlProps, autoplay, autoplayDelay, ...boxProps } = rest;
      return /* @__PURE__ */ React.createElement(Box, { ...boxProps, mod, ref, className: clsx(className, "kohler-message-banner-root") }, /* @__PURE__ */ React.createElement(PromoBanner, { content, carouselControlProps, autoplay, autoplayDelay }));
    }
    case "global": {
      const { content, carouselControlProps, ...boxProps } = rest;
      return /* @__PURE__ */ React.createElement(Box, { ...boxProps, mod, ref, className: clsx(className, "kohler-message-banner-root") }, /* @__PURE__ */ React.createElement(GlobalBanner, { content, carouselControlProps }));
    }
    case "info": {
      const { content, ...boxProps } = rest;
      return /* @__PURE__ */ React.createElement(Box, { ...boxProps, mod, ref, className: clsx(className, "kohler-message-banner-root") }, /* @__PURE__ */ React.createElement(InfoBanner, { content }));
    }
    default: {
      return null;
    }
  }
});

export { MessageBanner };
